export const pmData = {
  id: 'pm',
  title: 'Project Manager',
  icon: 'Users',
  color: 'from-purple-500 to-pink-600',
  description: 'Metodologías ágiles, herramientas de gestión y plantillas',
  categories: [
    {
      name: 'Metodologías Ágiles',
      icon: 'BarChart3',
      resources: [
        {
          id: 'scrum-1',
          title: 'Scrum Master - Certificación',
          type: 'Guía',
          description: 'Preparación completa para certificación de Scrum Master, incluyendo fundamentos, roles y preparación del examen.',
          tags: ['Scrum', 'Agile', 'Certificación'],
          difficulty: 'Avanzado',
          estimatedTime: '4h',
          lastUpdated: '2024-01-15',
          author: 'Agile Team',
          downloads: 145,
          rating: 4.8,
          content: {
            sections: [
              {
                title: 'Fundamentos de Scrum',
                content: 'Principios básicos y valores fundamentales de la metodología Scrum.',
                subsections: [
                  'Agile Manifesto',
                  'Scrum Values',
                  'Scrum Pillars',
                  'Empirical Process Control',
                  'Iterative and Incremental'
                ]
              },
              {
                title: 'Roles y Responsabilidades',
                content: 'Definición clara de los roles en Scrum y sus responsabilidades específicas.',
                subsections: [
                  'Product Owner',
                  'Scrum Master',
                  'Development Team',
                  'Stakeholders',
                  'Role interactions'
                ]
              },
              {
                title: 'Eventos Scrum',
                content: 'Eventos formales de Scrum y su propósito en el proceso de desarrollo.',
                subsections: [
                  'Sprint Planning',
                  'Daily Scrum',
                  'Sprint Review',
                  'Sprint Retrospective',
                  'Sprint'
                ]
              },
              {
                title: 'Artefactos',
                content: 'Artefactos de Scrum y su importancia en la transparencia e inspección.',
                subsections: [
                  'Product Backlog',
                  'Sprint Backlog',
                  'Increment',
                  'Definition of Done',
                  'Definition of Ready'
                ]
              },
              {
                title: 'Preparación del Examen',
                content: 'Estrategias y recursos para preparar exitosamente la certificación de Scrum Master.',
                subsections: [
                  'Study materials',
                  'Practice exams',
                  'Exam format',
                  'Key concepts',
                  'Test-taking strategies'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Scrum-Master-Certificacion.pdf',
              type: 'application/pdf',
              size: 3072000
            },
            {
              name: 'Scrum-Study-Guide.zip',
              type: 'application/zip',
              size: 2048000
            }
          ],
          externalLinks: [
            {
              title: 'Scrum.org Certification',
              description: 'Certificación oficial de Scrum.org',
              url: 'https://www.scrum.org/certifications/professional-scrum-master-i'
            }
          ]
        },
        {
          id: 'kanban-1',
          title: 'Kanban - Implementación',
          type: 'Tutorial',
          description: 'Implementación práctica de metodología Kanban en equipos de desarrollo y operaciones.',
          tags: ['Kanban', 'Agile', 'Gestión'],
          difficulty: 'Intermedio',
          estimatedTime: '2h',
          lastUpdated: '2024-01-12',
          author: 'Agile Team',
          downloads: 178,
          rating: 4.7,
          content: {
            sections: [
              {
                title: 'Principios de Kanban',
                content: 'Fundamentos y principios que rigen la metodología Kanban.',
                subsections: [
                  'Visualize the workflow',
                  'Limit work in progress',
                  'Manage flow',
                  'Make policies explicit',
                  'Implement feedback loops',
                  'Improve collaboratively'
                ]
              },
              {
                title: 'Configuración del Board',
                content: 'Diseño y configuración de tableros Kanban efectivos.',
                subsections: [
                  'Column design',
                  'Swim lanes',
                  'Card types',
                  'Color coding',
                  'Board layout'
                ]
              },
              {
                title: 'Work in Progress Limits',
                content: 'Implementación y gestión de límites de trabajo en progreso.',
                subsections: [
                  'WIP calculation',
                  'Setting limits',
                  'Enforcing limits',
                  'Adjusting limits',
                  'WIP monitoring'
                ]
              },
              {
                title: 'Métricas y KPIs',
                content: 'Métricas clave para medir el rendimiento y la eficiencia del flujo de trabajo.',
                subsections: [
                  'Cycle time',
                  'Lead time',
                  'Throughput',
                  'Cumulative flow',
                  'Flow efficiency'
                ]
              },
              {
                title: 'Mejora Continua',
                content: 'Procesos de mejora continua y optimización del flujo de trabajo.',
                subsections: [
                  'Kaizen events',
                  'Process improvement',
                  'Bottleneck identification',
                  'Flow optimization',
                  'Team collaboration'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'Kanban Guide',
              description: 'Guía oficial de Kanban',
              url: 'https://kanban.university/'
            }
          ]
        }
      ]
    },
    {
      name: 'Herramientas',
      icon: 'BookOpen',
      resources: [
        {
          id: 'jira-1',
          title: 'Jira Avanzado - Configuración',
          type: 'Guía',
          description: 'Configuración avanzada de Jira para proyectos complejos, incluyendo workflows personalizados y reporting.',
          tags: ['Jira', 'Gestión', 'Configuración'],
          difficulty: 'Intermedio',
          estimatedTime: '2.5h',
          lastUpdated: '2024-01-10',
          author: 'Tools Team',
          downloads: 234,
          rating: 4.6,
          content: {
            sections: [
              {
                title: 'Workflows Personalizados',
                content: 'Diseño y configuración de workflows personalizados para diferentes tipos de proyectos.',
                subsections: [
                  'Workflow design principles',
                  'Status configuration',
                  'Transition rules',
                  'Conditions and validators',
                  'Post functions'
                ]
              },
              {
                title: 'Custom Fields',
                content: 'Creación y configuración de campos personalizados para necesidades específicas del proyecto.',
                subsections: [
                  'Field types',
                  'Field configuration',
                  'Validation rules',
                  'Default values',
                  'Field dependencies'
                ]
              },
              {
                title: 'Dashboards Avanzados',
                content: 'Creación de dashboards personalizados para monitoreo de métricas del proyecto.',
                subsections: [
                  'Dashboard creation',
                  'Gadget configuration',
                  'Filter setup',
                  'Refresh settings',
                  'Dashboard sharing'
                ]
              },
              {
                title: 'Reporting y Analytics',
                content: 'Generación de reportes avanzados y análisis de datos del proyecto.',
                subsections: [
                  'Built-in reports',
                  'Custom reports',
                  'Metrics calculation',
                  'Trend analysis',
                  'Export options'
                ]
              },
              {
                title: 'Integraciones',
                content: 'Integración de Jira con otras herramientas de desarrollo y gestión.',
                subsections: [
                  'Git integration',
                  'CI/CD integration',
                  'Confluence integration',
                  'Slack integration',
                  'Third-party tools'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Jira-Avanzado-Guia.pdf',
              type: 'application/pdf',
              size: 3584000
            }
          ]
        },
        {
          id: 'confluence-1',
          title: 'Confluence - Documentación',
          type: 'Tutorial',
          description: 'Uso efectivo de Confluence para documentación de proyectos y colaboración en equipo.',
          tags: ['Confluence', 'Documentación', 'Colaboración'],
          difficulty: 'Básico',
          estimatedTime: '1.5h',
          lastUpdated: '2024-01-18',
          author: 'Documentation Team',
          downloads: 189,
          rating: 4.5,
          content: {
            sections: [
              {
                title: 'Creación de Espacios',
                content: 'Configuración y organización de espacios de trabajo en Confluence.',
                subsections: [
                  'Space types',
                  'Space organization',
                  'Permission management',
                  'Space templates',
                  'Space administration'
                ]
              },
              {
                title: 'Templates y Macros',
                content: 'Uso de templates y macros para estandarizar la documentación.',
                subsections: [
                  'Template creation',
                  'Macro usage',
                  'Custom templates',
                  'Template sharing',
                  'Best practices'
                ]
              },
              {
                title: 'Colaboración en Tiempo Real',
                content: 'Herramientas de colaboración para trabajo en equipo efectivo.',
                subsections: [
                  'Real-time editing',
                  'Comments and feedback',
                  'Version history',
                  'Change tracking',
                  'Collaboration features'
                ]
              },
              {
                title: 'Versionado de Documentos',
                content: 'Gestión de versiones y control de cambios en la documentación.',
                subsections: [
                  'Version management',
                  'Change tracking',
                  'Rollback procedures',
                  'Version comparison',
                  'Change notifications'
                ]
              },
              {
                title: 'Integración con Jira',
                content: 'Configuración de integración bidireccional entre Confluence y Jira.',
                subsections: [
                  'Integration setup',
                  'Jira issues in Confluence',
                  'Confluence pages in Jira',
                  'Automated updates',
                  'Workflow integration'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'Confluence Documentation',
              description: 'Documentación oficial de Confluence',
              url: 'https://confluence.atlassian.com/'
            }
          ]
        }
      ]
    },
    {
      name: 'Plantillas & Documentos',
      icon: 'FileText',
      resources: [
        {
          id: 'templates-1',
          title: 'Plantillas de Proyecto',
          type: 'Plantillas',
          description: 'Colección completa de plantillas para gestión integral de proyectos, incluyendo todas las fases del ciclo de vida.',
          tags: ['Plantillas', 'Proyectos', 'Documentos'],
          difficulty: 'Básico',
          estimatedTime: '1h',
          lastUpdated: '2024-01-14',
          author: 'PM Team',
          downloads: 298,
          rating: 4.8,
          content: {
            sections: [
              {
                title: 'Project Charter',
                content: 'Plantilla para el documento de autorización del proyecto y definición de objetivos.',
                subsections: [
                  'Project overview',
                  'Business case',
                  'Objectives and goals',
                  'Stakeholder identification',
                  'Success criteria'
                ]
              },
              {
                title: 'Project Plan',
                content: 'Plantilla para el plan de proyecto detallado con cronograma y recursos.',
                subsections: [
                  'Scope statement',
                  'Schedule and milestones',
                  'Resource allocation',
                  'Budget planning',
                  'Risk management'
                ]
              },
              {
                title: 'Risk Register',
                content: 'Plantilla para identificación, análisis y gestión de riesgos del proyecto.',
                subsections: [
                  'Risk identification',
                  'Risk assessment',
                  'Risk response strategies',
                  'Risk monitoring',
                  'Contingency planning'
                ]
              },
              {
                title: 'Stakeholder Matrix',
                content: 'Plantilla para análisis y gestión de stakeholders del proyecto.',
                subsections: [
                  'Stakeholder identification',
                  'Interest and influence',
                  'Communication needs',
                  'Engagement strategies',
                  'Stakeholder management'
                ]
              },
              {
                title: 'Communication Plan',
                content: 'Plantilla para planificación de comunicaciones del proyecto.',
                subsections: [
                  'Communication objectives',
                  'Audience analysis',
                  'Communication methods',
                  'Frequency and timing',
                  'Feedback mechanisms'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Plantillas-Proyecto.zip',
              type: 'application/zip',
              size: 5120000
            },
            {
              name: 'Guia-Plantillas.pdf',
              type: 'application/pdf',
              size: 2048000
            }
          ],
          externalLinks: [
            {
              title: 'PMI Templates',
              description: 'Plantillas oficiales del Project Management Institute',
              url: 'https://www.pmi.org/pmbok-guide-standards'
            }
          ]
        },
        {
          id: 'templates-2',
          title: 'Reportes de Estado',
          type: 'Plantillas',
          description: 'Plantillas para reportes de estado semanales y mensuales con métricas y seguimiento de progreso.',
          tags: ['Reportes', 'Estado', 'Comunicación'],
          difficulty: 'Básico',
          estimatedTime: '30m',
          lastUpdated: '2024-01-16',
          author: 'PM Team',
          downloads: 167,
          rating: 4.7,
          content: {
            sections: [
              {
                title: 'Status Report Template',
                content: 'Plantilla estándar para reportes de estado semanales del proyecto.',
                subsections: [
                  'Executive summary',
                  'Progress overview',
                  'Milestone status',
                  'Issues and risks',
                  'Next steps'
                ]
              },
              {
                title: 'Executive Summary',
                content: 'Resumen ejecutivo para stakeholders de alto nivel.',
                subsections: [
                  'Key achievements',
                  'Major milestones',
                  'Budget status',
                  'Schedule status',
                  'Risk overview'
                ]
              },
              {
                title: 'Progress Tracking',
                content: 'Seguimiento detallado del progreso del proyecto.',
                subsections: [
                  'Task completion',
                  'Milestone progress',
                  'Resource utilization',
                  'Quality metrics',
                  'Performance indicators'
                ]
              },
              {
                title: 'Issues y Risks',
                content: 'Identificación y seguimiento de problemas y riesgos actuales.',
                subsections: [
                  'Current issues',
                  'Risk status',
                  'Mitigation actions',
                  'Escalation procedures',
                  'Resolution timeline'
                ]
              },
              {
                title: 'Next Steps',
                content: 'Planificación de próximas acciones y actividades.',
                subsections: [
                  'Upcoming milestones',
                  'Resource requirements',
                  'Dependencies',
                  'Timeline adjustments',
                  'Action items'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Reportes-Estado.zip',
              type: 'application/zip',
              size: 1536000
            }
          ]
        }
      ]
    }
  ]
};
